import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import checkPlugin from './plugins/check'
import CommonComponentsPlugin from './plugins/CommonComponents'
import CommonPlugin from './plugins/common'
import VCalendar from 'v-calendar'
import { setupInterceptors } from './utils/interceptors'

Vue.config.productionTip = false
Vue.use(require('vue-moment'))
Vue.use(checkPlugin)
Vue.use(CommonComponentsPlugin)
Vue.use(CommonPlugin)
Vue.use(VCalendar)

const app = new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    setupInterceptors(store);
  }
}).$mount('#app')
